var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"volume"},[_c('Icon',{staticClass:"icon",attrs:{"size":20,"type":_vm.getIconType()},on:{"click":_vm.toggleSilence}}),_c('div',{staticClass:"progress-wrap"},[_c('ProgressBar',{attrs:{"percent":_vm.volumePercent,"alwaysShowBtn":""},on:{"percentChange":_vm.onProgressChange}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }